export function normalizeApiFileUrl(url?: string | null): string {
    if (!url) {
        return "";
    }

    return url.replace("/file/file/get/", "/get-file/");
}
